import * as React from 'react'

import { Theme, styled } from '@mui/material/styles'

//Dialog
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Paper, { PaperProps } from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

// icons
import Close from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import CloudUpload from '@mui/icons-material/CloudUpload';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseArrowIcon from '@mui/icons-material/Pause';
import DragHandleIcon from '@mui/icons-material/MoreHoriz';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import StarBorder from '@mui/icons-material/StarBorder';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import StarIcon from '@mui/icons-material/Star';

import { WorkAreaHandlers } from '../../WorkArea';

import UserAsset from "../../../../api/model/UserAsset";
import Asset from "../../../../api/model/Asset";
import AssetFav from "../../../../api/model/AssetFav";
import BackgroundFav from "../../../../api/model/BackgroundFav";
import AudioFav from "../../../../api/model/AudioFav";
import IWideoAssetCategory from "../../../../api/model/IWideoAssetCategory";
import IStockAssetCategory from "../../../../api/model/IStockAssetCategory";

import UploadAssetDialogActions from './UploadAssetDialogActions';

import ConversionUtils from '../rightbar/object/ConversionUtils';
import SearchButton from '../utils/SearchButton';
import Placeholder from '../utils/Placeholder';
import Editor from '../../../core/Editor';
import SearchTermResultItem from '../../../../api/model/SearchTermResultItem';
import { formatMsToMMSS } from '../rightbar/audio/AudioAttributes';

import update from 'immutability-helper';
import Draggable, { DraggableData } from 'react-draggable';

import { imageMimeTypes, backMimeTypes, audioMimeTypes, imageFileTypes, backFileTypes, audioFileTypes, videoFileTypes, AssetSearchSource, imageMaxFileSize, backMaxFileSize, audioMaxFileSize, videoMaxFileSize, videoMaxDuration, videoMaxNoOfObjectsPerScene, audioMaxFilesWideo, videoMaxNoOfObjectsPerWideo, resourcesBaseUrl, filterObjs, ReplaceTarget, wideoAssetStyles } from '../../../core/EditorConstants';

import { WithTranslation, withTranslation } from 'react-i18next';

import { Suspense } from 'react';
import { getBackgroundMainColor, getWhiteColor } from './FontDialog';
import { getBackgroundColor200 } from './search/SearchProvider';
import theme from 'src/common/ui/theme';
import './UploadAssetDialog.css';
import { BrandContext } from 'src/common/ui/BrandContextProvider';
import { Input } from '@mui/material';

const UploadAssetVideoDialog = React.lazy(() => import('./UploadAssetVideoDialog'));

const cellHeight: number = 147
const cellHeightVideo: number = 120
const cellHeightCat: number = 174
const cellHeightItem: number = 147
const colsGridList: number = 3
const colsGridListMedia: number = 2
const colsGridListCat: number = 2
const colsGridListTile: number = 1
const insetThumbnail: number = 10

export const getBorder = (theme: Theme) => ({
  border: `${insetThumbnail}px solid ${theme.palette.grey[200]}`,
});

export const getBorderAlt = (theme: Theme) => ({
  border: `${insetThumbnail / 2}px solid ${theme.palette.grey[200]}`,
});

export const getColor600 = (theme: Theme) => ({
  color: theme.palette.grey['600'],
});

export const getColor800 = (theme: Theme) => ({
  color: theme.palette.grey['800'],
});

export const getBackgroundWhiteColor = (theme: Theme) => ({
  backgroundColor: theme.palette.common.white,
});

const styles = {
  gridList: {
    width: '100%',
    margin: '0!important',
    overflow: 'hidden'
  },
  buttonUploadIcon: {
    marginRight: '8px'
  },
  buttonBack: {
    ...getWhiteColor(theme),
    width: '48px'
  },
  inputFile: {
    fontSize: '100px',
    position: 'absolute' as 'absolute',
    left: 0,
    top: 0,
    opacity: 0
  },
  dialogAppBar: {
    backgroundColor: '#424242',
    boxShadow: 'none'
  },
  dialog: {
    justifyContent: 'flex-start' as React.CSSProperties['justifyContent'],
  },
  scrollPaper: {
    justifyContent: 'flex-start' as 'flex-start',
    alignItems: 'flex-start' as React.CSSProperties['alignItems'],
  },
  dialogContent: {
    padding: '2px 2px 2px 1px',
  },
  mediaUpload: {
    height: `${cellHeightItem - insetThumbnail * 2}px`,
    padding: '0',
    width: `calc(100% - ${insetThumbnail * 2}px)`,
    ...getBorder(theme),
    backgroundSize: 'contain',
    ...getBackgroundColor200(theme),
  },
  BackgroundUpload: {
    height: cellHeightItem,
    padding: '0',
    width: '100%',
    backgroundSize: '100%',
    ...getBackgroundColor200(theme),
  },
  mediaCat: {
    height: cellHeightItem,
    padding: '0',
  },
  mediaImg: {
    height: `${cellHeightItem - insetThumbnail}px`,
    padding: '0',
    width: `calc(100% - ${insetThumbnail}px)`,
    ...getBorderAlt(theme),
    backgroundSize: 'contain',
  },
  mediaVideo: {
    height: cellHeightItem,
    padding: '0',
    width: '100%',
    backgroundSize: '95%',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 70%, rgba(0,0,0,0) 100%)',
    position: 'absolute' as 'absolute',
    height: '100%',
  },
  titleWrap: {
    position: 'absolute' as 'absolute',
    bottom: '5px',
  },
  mb2: {
    marginBottom: '10px',
  },
  p2: {
    padding: '10px',
  },
  iconAction: {
    marginLeft: 'auto',
  },
  textAudio: {
    maxWidth: '170px',
    display: 'block',
    margin: '0',
    lineHeight: '17px',
    ...getColor600(theme),
  },
  iconPlay: {
    padding: '5px',
    ...getColor600(theme),
  },
  expansionCurrentPanelSummary: {
    ...getWhiteColor(theme),
    ...getBackgroundMainColor(theme),
  },
  expansionPanelSummary: {
    ...getColor800(theme),
    ...getBackgroundWhiteColor(theme),
  },
  expansionPanelSummaryIcon: {
    ...getColor800(theme),
  },
  expansionCurrentPanelSummaryIcon: {
    ...getWhiteColor(theme),
  },
  expansionPanelSummaryContent: {
    margin: '12px 0'
  },
  expansionPanelDetails: {
    padding: '1px 0 20px 0',
    width: '100%',
    margin: '0px!important'
  },
  card: {
    margin: 0,
    position: 'relative' as 'relative',
    boxShadow: 'none',
    ...getBackgroundColor200(theme),
    '&:hover': {
      '& .cardActions': {
        opacity: 1,
      }
    }
  },
  cardSound: {
    padding: '18px 0'
  },
  cardActions: {
    opacity: 0,   
  },
  imageSound: {
    width: 68,
    height: 68,
  },
  imgSound: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  paper: {
    marginLeft: 2,
    marginTop: 2,
    ...getWhiteColor(theme),
    ...getBackgroundWhiteColor(theme),
    borderRadius: 4,
  },
  tabRoot: {
    minWidth: 75,
    fontSize: 13,
    padding: '6px 8px'
  },
  tabSm: {
    minWidth: 40
  },
  fileTypes: {
    textTransform: 'uppercase' as React.CSSProperties['textTransform']
  },
  dialogActions: {
    padding: '8px 20px',
    display: 'block',
    width: '260px',
    margin: '0 auto',
  },
  draggableArea: {
    opacity: 0,
    transition: 'all 0.25s ease-out',
    '&:hover': {
      opacity: 1,
    }
    }
};

const CustomDialog = styled(Dialog)(() => ({
  '.MuiDialog-scrollPaper': styles.scrollPaper,
  '.MuiDialog-root': styles.dialog,
  '.MuiDialog-paper': styles.paper,
}));



interface Props {
  handlers: WorkAreaHandlers;
  editor: Editor,
  isDialogOpen: boolean,
  handleCloseDialog: () => void,
  handleFileSelection: (e: React.SyntheticEvent<HTMLElement>) => void,
  handleDeleteAsset: (wideoId: string, assetId: string) => void,
  handleSelectAsset: (asset: Asset) => void,
  handleSaveAsFavAsset: (assetId: string) => void,
  handleDeleteAsFavAsset: (assetId: string) => void,
  handleSearchSelection: (searchItem: SearchTermResultItem) => void,
  handlePlayAsset: (ref: HTMLVideoElement | string, url: string, isPlaying: boolean) => void,
  dialogTitle: string,
  dialogDesc: string,
  libraryTabLabel: string,
  uploadedTabLabel: string,
  stockTabLabel: string,
  data: DialogData,
  customTab: CustomTab,
  multiple?: boolean,
  accept: string,
  tabOpen?: ReplaceTarget,
  assetSearchSources?: AssetSearchSource[],
  handleOpenAddAudioDialog: (asset: Asset) => void
}

interface State {
  value: number, //tab number 
  fileSelectorOpen: boolean, //to track when file selector is opened
  styleSelected: IWideoAssetCategory,
  anchorEl: HTMLElement,
  expansionPanelDataForWideo: ExpansionPanelDataForWideo[], // collection used as cache, to save the loaded
  //expansionPanelDetails that shows the assetInfo
  isToggleIconOn: {},
  isDraggable: boolean,
  cursorName: string,
  defaultSearch: string,
  isSearchDialogOpen: boolean
  filter: string;
}

export interface DialogDataUserAssetsByWideo {
  wideoId: string,
  wideoTitle: string,
  isCurrentWideo: boolean,
  userAssets: UserAsset[]
}

export interface CustomTab {
  tabTitle: string,
  tabContent: () => JSX.Element
}

interface ExpansionPanelDataForWideo {
  wideo: DialogDataUserAssetsByWideo
}

/**
 * data object used to show info of assets
*/
export interface DialogData {
  wideos: DialogDataUserAssetsByWideo[],
  wideoAssetStyles: IWideoAssetCategory[],
  stockAssetStyles: IStockAssetCategory[],
  assetFavs: AssetFav[] | BackgroundFav[] | AudioFav[]
  assetShared: Asset[]
}

type Styled = any

type PropsWithStyles = Props & WithTranslation & Styled;


/**
 * Generic asset dialog to show assets of the same type at once.
 * Used for images, backgrounds and audios
 *
 * The dialog receives a list of user uplladed assets (image, background or audios)
 * grouped by wideoId, and a list of wideo asset (images, backs or audios)
 */
class UploadAssetDialog extends React.Component<PropsWithStyles, State>{

  private debounceTimeout: ReturnType<typeof setTimeout> | null = null;

  private fileInput: HTMLInputElement;

  constructor(props: PropsWithStyles) {
    super(props as PropsWithStyles);
    this.state = this.stateFromProps(props);
  }

  static contextType = BrandContext;
  context: React.ContextType<typeof BrandContext>

  private stateFromProps = (props: PropsWithStyles): State => {
    return {
      value: 0,
      styleSelected: null,
      fileSelectorOpen: false,
      anchorEl: null,
      expansionPanelDataForWideo: [],
      isToggleIconOn: {},
      isDraggable: true,
      cursorName: 'grab',
      defaultSearch: '',
      isSearchDialogOpen: false,
      filter: ''
    };
  }

  componentDidUpdate(prevProps: Props) {
    const newValue = this.getTabValue();

    if (prevProps.isDialogOpen !== this.props.isDialogOpen && !this.props.isDialogOpen) {
      //when close reset state
      this.resetState(newValue);
    }

    if (prevProps.tabOpen !== this.props.tabOpen) {
      this.setState({ value: newValue });
    }
    if ((this.props.tabOpen === ReplaceTarget.UploadImage || this.props.tabOpen === ReplaceTarget.UploadVideo) && this.props.isDialogOpen && !this.state.fileSelectorOpen) {
      this.setState({ fileSelectorOpen: true });
      this.triggerInputFile();
    }

    //generate expansion panels and update cache for current wideo
    if (prevProps.data.wideos !== this.props.data.wideos) {
      this.props.data.wideos.map((wideo: DialogDataUserAssetsByWideo, index: number) => {
        //check if there are changes
        if (wideo.isCurrentWideo) {
          this.setExpansionPanelDataForWideo(wideo);
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

  renderUploadAssetDialogActions = (asset: (Asset | UserAsset), isDeletableAsset: boolean, isFavAsset: boolean, isSharedAsset: boolean) => {
    return (
      <UploadAssetDialogActions
        editor={this.props.editor}
        handlers={this.props.handlers}
        handleDeleteAsset={isDeletableAsset ? this.props.handleDeleteAsset : null}
        handlePlayAsset={this.props.handlePlayAsset}
        handleSelectAsset={this.props.handleSelectAsset}
        handleSaveAsFavAsset={this.props.handleSaveAsFavAsset}
        handleDeleteAsFavAsset={this.props.handleDeleteAsFavAsset}
        assets={[asset]}
        isVideoAsset={false}
        isFavAsset={isFavAsset}
        isSharedAsset={isSharedAsset}
        data={this.props.data}
        assetFavKeyId={this.getAssetKeyId}
        assetFavIndex={this.getAssetFavIndex}
        assetSharedKeyId={this.getSharedAssetKeyId}
        assetSharedIndex={this.getAssetSharedIndex}
        handleOpenAddAudioDialog={this.props.handleOpenAddAudioDialog}
      />
    );
  }

  renderToggleIconPlayPause = (asset: (Asset | UserAsset)) => {
    const isPlaying: boolean = this.state.isToggleIconOn[asset.id] !== undefined && this.state.isToggleIconOn[asset.id]

    return isPlaying ? 
      <PauseArrowIcon onClick={() => { this.handleIconPause(asset.id, asset.url) }} /> : 
      <PlayArrowIcon onClick={() => { this.handleIconPlay(asset.id, asset.url) }} /> 
  }

  renderWideoObjectsTabStyle = (props: PropsWithStyles, style: IWideoAssetCategory) => {
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    const categories = this.getCategories(style.categories)

    return (
      <DialogContent 
        style={styles.dialogContent}
      >
        {categories.map((cat: IWideoAssetCategory) => {
            const objects = cat.objects.filter(
              (obj) =>
                !(this.props.uploadedTabLabel == "My audios") || //All items must available if not in "audios" tab.
                obj.name.toLocaleLowerCase().includes(this.state.filter)
            ).map((object: Asset) => {

            return (
              <ImageListItem
                cols={colsGridListTile} key={cat.name + object.id} sx={{ cursor: 'pointer', overflow: 'hidden' }}>
                <Card cyclass="assetDialogWideoAssetItem" className="Card"
                    style={
                      this.props.handlePlayAsset && !isVideoAsset
                        ? { ...styles.card, ...styles.cardSound }
                        : styles.card
                    }
                  >
                  {!this.props.handlePlayAsset &&
                    <>
                      <CardMedia
                        onClick={() => { this.props.handleSelectAsset(object) }}
                        style={object.fullWidthPreview ? styles.BackgroundUpload : styles.mediaUpload}
                        image={object.preview}
                        id={"Jest-" + cat.name + object.id}
                        cyid={"objectSelector" + cat.name + object.id}
                      />
                      <CardActions
                        className="CardActions"
                        disableSpacing
                        style={{ ...styles.cardActions }}
                      >
                        {this.renderUploadAssetDialogActions(object, false, false, false)}
                      </CardActions>
                    </>
                  }
                  {this.props.handlePlayAsset && !isVideoAsset &&
                    <span cyclass="assetDialogWideoAssetItem">
                      {this.renderAudioElement(object, false, false, false)}
                    </span>
                  }

                </Card>
              </ImageListItem>
            )
          });

          return (
            <React.Fragment key={cat.name}>
              <Accordion style={styles.mb2} defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  {cat.name}
                </AccordionSummary>
                <AccordionDetails
                  style={{ ...styles.expansionPanelDetails }}
                >
                  {this.props.uploadedTabLabel == "My audios" && ( //Show filter option only in "audios" tab.
                    <Input placeholder="Filter" onChange={this.filterAudios} style={{
                      marginLeft: '15px',
                      marginBottom: '10px'
                    }}/>
                  )}
                  <ImageList
                    cols={this.props.handlePlayAsset ? colsGridListMedia : colsGridList}
                    rowHeight={cellHeight}
                    gap={3}
                    style={{ ...styles.gridList }}
                  >
                    {objects}
                  </ImageList>
                </AccordionDetails>
              </Accordion >
            </React.Fragment>
          )
        })
        }
      </DialogContent >
    );
  }

  renderWideoObjectsTabStyleSelected = () => {
    if (this.state.value === 0 && this.state.styleSelected) {
      return this.renderWideoObjectsTabStyle(this.props, this.state.styleSelected);
    }
    else { return (<span key={6} />) }
  }

  //returns container of wideoObjects tab
  renderWideoObjectsTab = () => {
    if (this.state.value === 0 && !this.state.styleSelected && this.props.data) {
      if (this.props.data.wideoAssetStyles.length === 1) {
        const defaultStyle = this.props.data.wideoAssetStyles[0];

        return this.renderWideoObjectsTabStyle(this.props, defaultStyle);
      }
      return (
        <DialogContent style={styles.dialogContent}>
          <ImageList
            rowHeight={cellHeightCat}
            cols={colsGridListCat}
            gap={3}
            style={{ ...styles.gridList }}
          >
            {this.props.data.wideoAssetStyles.map(style => {
              return (
                <ImageListItem
                  cols={colsGridListTile}
                  key={style.id}
                  sx={{ cursor: 'pointer', overflow: 'hidden' }}
                  onClick={() => { this.handleOnClickStyle(style) }}
                  id={"Jest-styleIcon" + style.id}
                  cyid={"styleIcon-" + style.id}
                >
                  <img
                    src={resourcesBaseUrl + '/img/editor/icons/styles/' + style.id + '.jpg'}
                    alt={style.name}
                    style={{ 
                      maxWidth: 'fit-content', 
                      top: '50%',
                      width: '100%',
                      position: 'relative',
                      transform: 'translateY(-50%)' 
                    }}
                  />
                  <ImageListItemBar
                    title={style.name}
                    style={{
                      ...styles.titleBar,
                    }}
                    className="titleWrap"
                  />
                </ImageListItem>
              )
            })}
          </ImageList>
        </DialogContent>
      );
    }
    else { return (<span key={1} />) }
  }

  getTabValue = () => {
    let newValue = 0;

    switch (this.props.tabOpen) {
      case 'stockVideos':
      case 'objects': {
        newValue = 0;
        break;
      }
      case 'stockImages':
      case 'myVideos': {
        newValue = 1;
        break;
      }
      case 'tts':
      case 'myImages': {
        newValue = 2;
        break;
      }
      default:
        break;
    }
    return newValue
  }

  getExpansionPanelForWideo = (wideo: DialogDataUserAssetsByWideo): JSX.Element => {
    
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    return (
      <React.Fragment key={wideo.wideoId}>
        <Accordion cyclass="assetDialogMyLibraryWideoExpansionPanel" onChange={(event: React.ChangeEvent<{}>, expanded: boolean) => {
          if (expanded) {
            //load when panel is opened
            this.setExpansionPanelDataForWideo(wideo);
          }
        }}
          defaultExpanded={wideo.isCurrentWideo}
          style={styles.mb2}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
          >
            {(wideo.wideoTitle === 'untitled' ? wideo.wideoTitle + ' (' + wideo.wideoId + ')' : wideo.wideoTitle)}
          </AccordionSummary>
          <AccordionDetails
            style={{
              ...styles.expansionPanelDetails
            }}
          >
            <ImageList
              rowHeight={isVideoAsset ? cellHeightVideo : cellHeight}
              cols={this.props.handlePlayAsset ? colsGridListMedia : colsGridList}
              gap={3}
              style={{ ...styles.expansionPanelDetails }}
            >
              {this.getExpansionPanelDataForWideo(wideo)}
            </ImageList>
          </AccordionDetails >
        </Accordion >
      </React.Fragment>
    );
  }

  getExpansionPanelDataForWideo = (wideo: DialogDataUserAssetsByWideo): JSX.Element[] => {
    const expansionPanelDataForWideos: ExpansionPanelDataForWideo[] = filterObjs((expansionPanelDataForWideo: ExpansionPanelDataForWideo) => expansionPanelDataForWideo.wideo.wideoId === wideo.wideoId)(this.state.expansionPanelDataForWideo);

    if (expansionPanelDataForWideos && expansionPanelDataForWideos.length > 0) {
      return this.renderUserAssets(wideo);
    } else {
      return ([<span key={'expansionPanelDataForWideo'} />])
    }
  }

  getCategories = (cats: IWideoAssetCategory[]) => {
    const { styleSelected } = this.state
    const isAnimatedObjects = styleSelected && styleSelected.name.toLowerCase() === wideoAssetStyles.ANIMATED

    if(isAnimatedObjects) {
      return [...cats].reverse()
    }

    return cats
  }  

  setExpansionPanelDataForWideo = (wideo: DialogDataUserAssetsByWideo): void => {
    const expansionPanelDataForWideos: ExpansionPanelDataForWideo[] = filterObjs((expansionPanelDataForWideo: ExpansionPanelDataForWideo) => expansionPanelDataForWideo.wideo.wideoId === wideo.wideoId)(this.state.expansionPanelDataForWideo);
    if (expansionPanelDataForWideos && expansionPanelDataForWideos.length === 0) {
      const expansionPanelDataForWideo: ExpansionPanelDataForWideo = { wideo: wideo };
      this.setState((prevState: State, props) => {
        const expansionPanelDataForWideoUpdate = update(prevState.expansionPanelDataForWideo, {
          $push: [expansionPanelDataForWideo]
        })
        return { expansionPanelDataForWideo: expansionPanelDataForWideoUpdate };
      })
    }
  }

  renderUserAssets = (wideo: DialogDataUserAssetsByWideo): JSX.Element[] => {
    
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    const assets =
      wideo.userAssets.map((asset: UserAsset) => {
        return (
          <ImageListItem
            cols={colsGridListTile} key={asset.id} sx={{ cursor: 'pointer', overflow: 'hidden' }}
          >
            <Card cyclass={"assetDialogUserAssetItem"} className="Card"
              style={
                this.props.handlePlayAsset && !isVideoAsset
                  ? { ...styles.card, ...styles.cardSound }
                  : styles.card
              }
            >
              {!this.props.handlePlayAsset && !isVideoAsset &&
                <>
                  <CardMedia
                    onClick={() => { this.props.handleSelectAsset(asset) }}
                    style={styles.mediaImg}
                    image={asset.preview}
                  />
                  <CardActions
                    className="CardActions"
                    disableSpacing
                    style={{ ...styles.cardActions }}
                  >
                    {this.renderUploadAssetDialogActions(asset, true, false, false)}
                  </CardActions>
                </>
              }
              {this.props.handlePlayAsset && !isVideoAsset && this.renderAudioElement(asset, true, false, false)
              }
              {isVideoAsset &&
                this.renderVideoAssetsDialog(asset, false, false)
              }
            </Card>
          </ImageListItem>)
      });
    return assets;
  }

  //returns container of user uploaded objects tab
  renderUserObjectsTab = () => {
    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();

    if (this.state.value === 1 && !isImageAsset || (isImageAsset && this.state.value === 2) && this.props.data) {

      //locate current wideo index

      const currentWideoIndex = this.props.data.wideos.findIndex(
        (wideo: DialogDataUserAssetsByWideo) => {
          return wideo.isCurrentWideo;
        });

      return (
        <DialogContent style={styles.dialogContent}>
          {currentWideoIndex > 0 && this.getExpansionPanelForWideo(this.props.data.wideos[currentWideoIndex])}

          {this.props.data.wideos.map((wideo: DialogDataUserAssetsByWideo) => {

            //If the wideo does not have any assets do not bother showing it in the list
            if (!wideo.userAssets || wideo.userAssets.length === 0) {
              return null;
            }
            else {
              return this.getExpansionPanelForWideo(wideo);
            }
          })}
        </DialogContent>);
    }
    else { return (<span key={2} />) }
  }

  renderBackToStylesButton = () => {
    if (this.state.styleSelected) {
      return (
        <IconButton
          onClick={() => { this.handleOnClickCloseStyle() }}
          style={{ ...styles.buttonBack }}
        >
          <ChevronLeftIcon />
        </IconButton>);
    }
    else {
      return (<span key={3} />);
    }
  }

  renderTabs = () => {
    const { t } = this.props;

    //default tabs
    const tabs: JSX.Element[] = [
      <Tab cyid={"assetDialogTabLibrary"} style={{ ...styles.tabRoot }} key="objects" label={this.props.libraryTabLabel} />,
      <Tab cyid={"assetDialogTabMyLibrary"} style={{ ...styles.tabRoot }} key="uploaded" label={this.props.uploadedTabLabel} />,
    ];

    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();

    //tab stock
    const stockElm = <Tab cyid={"assetDialogTabStock"} style={{ ...styles.tabRoot }} key="stock" label={this.props.stockTabLabel} />

    if (isImageAsset) {
      tabs.splice(1, 0, stockElm);
    }

    if (isVideoAsset) {
      tabs.shift()
      tabs.splice(0, 0, stockElm);
    }

    if (this.props.customTab) {
      tabs.push(<Tab cyid={isAudioAsset ? "assetDialogTabTextToSpeech" : "assetDialogTabColors"} style={{ ...styles.tabRoot }} key="custom" label={this.props.customTab.tabTitle} />);
    }

    //tab favAssets
    tabs.push(
      <Tooltip key="tooltipFavAsset" title={t("leftbar.commons.tabs.fav")}>
        <Tab cyid={"assetDialogTabFavAssets"} style={{ ...styles.tabSm }} key="favAssets" icon={<StarBorder />} />
      </Tooltip>
    );

    //tab sharedAssets
    tabs.push(
      <Tooltip key="tooltipSharedAsset" title={t("leftbar.commons.tabs.shared")}>
        <Tab cyid={"assetDialogTabSharedAssets"} style={{ ...styles.tabSm }} key="sharedAssets" icon={<PeopleAltOutlinedIcon />} />
      </Tooltip>
    );

    return (
      <div>
        <Box display="flex"
          sx={{ cursor: this.state.cursorName, textAlign: 'center', ...styles.draggableArea }}
        >
          <Box flexGrow={1}>
            <DragHandleIcon fontSize="small" />
          </Box>
          <Box>
            <Tooltip title={this.state.isDraggable ? t("leftbar.commons.unlock") : t("leftbar.commons.lock")}>
              <IconButton
                aria-label="lock/unlock tools"
                size="small"
                onClick={this.handleLockUnlockOptions}
              >
                <Box>
                  {this.state.isDraggable ? 
                    <LockOpenIcon htmlColor="#9e9e9e" fontSize="inherit" style={{ width: 14, height: 14 }} /> : 
                    <LockIcon htmlColor="#9e9e9e" fontSize="inherit" style={{ width: 14, height: 14 }} />
                  }
                </Box>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box mr={this.props.handleSearchSelection ? 9 : 0}>
          <Tabs value={this.state.value} onChange={this.handleChange} indicatorColor="primary" textColor="inherit">
            {tabs}
          </Tabs>
        </Box>
      </div>
    );
  }

  renderCustomTabContent = () => {
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();

    if (this.props.customTab && this.state.value === 2) {
      return (
        <DialogContent style={{ ...styles.dialogContent, ...(isAudioAsset ? styles.p2 : {}) }}>
          {this.props.customTab.tabContent()}
        </DialogContent>);
    }
    else {
      return (<span key={4} />);
    }
  }

  renderStockTabContent = () => {
    const { t } = this.props;
    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    if (isImageAsset && this.state.value === 1 || isVideoAsset && this.state.value === 0 && this.props.data) {

      return (
        <DialogContent style={styles.dialogContent}>
          <ImageList
            rowHeight={cellHeightCat}
            cols={colsGridListCat}
            gap={3}
            style={{ ...styles.gridList }}
          >
            {this.props.data.stockAssetStyles.map(style => {
              return (
                <ImageListItem
                  cols={colsGridListTile}
                  key={style.id}
                  sx={{ cursor: 'pointer', overflow: 'hidden' }}
                  onClick={() => { this.handleOnClickStockStyle(style) }}
                  id={"Jest-stockStyleCover-" + style.id}
                  cyid={"stockStyleCover-" + style.id}
                >
                  <img
                    src={style.image}
                    alt={t(`leftbar.commons.search.labels.${style.name}`)}
                    style={{ maxWidth: 'fit-content' }}
                  />
                  <ImageListItemBar
                    title={t(`leftbar.commons.search.labels.${style.name}`)}
                    style={{
                      ...styles.titleBar,
                    }}
                    className="titleWrap"
                    cyclass="stockStyleCategoryName"
                  />
                </ImageListItem>
              )
            })}
          </ImageList>
        </DialogContent>);
    }
    else {
      return (<span key={8} />);
    }
  }

  renderVideoAssetsDialog = (asset: (Asset | UserAsset), isFavAsset: boolean, isSharedAsset: boolean) => {
    return (
      <Suspense fallback={<></>}>

        <UploadAssetVideoDialog
          editor={this.props.editor}
          handlers={this.props.handlers}
          asset={asset}
          handleDeleteAsset={this.props.handleDeleteAsset}
          handlePlayAsset={this.props.handlePlayAsset}
          handleSelectAsset={this.props.handleSelectAsset}
          handleSaveAsFavAsset={this.props.handleSaveAsFavAsset}
          handleDeleteAsFavAsset={this.props.handleDeleteAsFavAsset}
          isFavAsset={isFavAsset}
          isSharedAsset={isSharedAsset}
          data={this.props.data}
          assetFavKeyId={this.getAssetKeyId}
          assetFavIndex={this.getAssetFavIndex}
          assetSharedKeyId={this.getSharedAssetKeyId}
          assetSharedIndex={this.getAssetSharedIndex}
          handleOpenAddAudioDialog={this.props.handleOpenAddAudioDialog}
        /></Suspense>
    )
  }

  renderFavAssets = (asset: (Asset | UserAsset), isDeletableAsset: boolean) => {
    

    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isBackAsset: boolean = this.props.accept === backMimeTypes.concat(backFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();

    return (
      <ImageListItem
        cols={colsGridListTile} key={`fav-asset-${asset.id}`} sx={{ cursor: 'pointer', overflow: 'hidden' }}>
        <Card cyclass={"assetDialogFavAssetItem"} className="Card"
            style={
              this.props.handlePlayAsset && !isVideoAsset
                ? { ...styles.card, ...styles.cardSound }
                : styles.card
            }
          >
          {(isImageAsset || isBackAsset) &&
            <>
              <CardMedia
                onClick={() => { this.props.handleSelectAsset(asset) }}
                style={styles.mediaImg}
                image={asset.preview}
              />
              <CardActions
                className="CardActions"
                disableSpacing
                style={{ ...styles.cardActions }}
              >
                {this.renderUploadAssetDialogActions(asset, isDeletableAsset, true, false)}
              </CardActions>
            </>
          }
          {isAudioAsset && this.renderAudioElement(asset, isDeletableAsset, true, false)}
          {(isVideoAsset && isDeletableAsset) && this.renderVideoAssetsDialog(asset, true, false)}
        </Card>
      </ImageListItem>
    );
  }

  renderFavWideoAssets = () => {
    let assetsFav: Asset[] = []

    this.props.data.wideoAssetStyles.forEach(({ categories }) => {
      categories.forEach(({ objects }) => {
        const filteredObjects = objects.filter(({ id }) => {
          return this.getAssetFavIndex().indexOf(id, 0) !== -1
        })
        assetsFav = [...assetsFav, ...filteredObjects];
      })
    });

    return assetsFav.map((asset) => this.renderFavAssets(asset, true))
  }

  renderFavUserAssets = () => {
    let assetsFav: UserAsset[] = []

    this.props.data.wideos.forEach(({ userAssets }) => {
      const filteredUserAssets = userAssets.filter(({ id }) => {
        return this.getAssetFavIndex().indexOf(id, 0) !== -1
      })
      assetsFav = [...assetsFav, ...filteredUserAssets];
    });

    return assetsFav.map((asset) => this.renderFavAssets(asset, true))
  }

  renderFavs = () => {
    const { t } = this.props
    const favAssets = [...this.renderFavWideoAssets(), ...this.renderFavUserAssets()]

    if (!favAssets.length) {
      return (
        <Placeholder
          icon={<StarIcon htmlColor="#bbbbbb" fontSize="inherit" />}
          text={t('leftbar.commons.messages.any-favorite')}
        />);
    }

    return favAssets;
  }

  renderFavAssetsTabContent = () => {
    
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    if (isVideoAsset ? this.state.value === 2 : this.state.value === 3) {

      const favAssets = [...this.renderFavWideoAssets(), ...this.renderFavUserAssets()]

      return (
        <DialogContent
          style={{ ...styles.dialogContent }}
        >
          <ImageList
            cols={(this.props.handlePlayAsset && favAssets.length) ? colsGridListMedia : !favAssets.length ? 1 : colsGridList}
            rowHeight={isVideoAsset ? cellHeightVideo : cellHeight}
            gap={3}
            style={{ ...styles.gridList }}
          >
            {this.renderFavs()}
          </ImageList>
        </DialogContent>);
    }
    else {
      return <></>;
    }
  }

  getAssetKeyId = (assetFav: (AssetFav | BackgroundFav | AudioFav)): string => {

    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isBackAsset: boolean = this.props.accept === backMimeTypes.concat(backFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();

    if (isImageAsset || isVideoAsset) {
      return assetFav['assetIDasString'];
    } else if (isBackAsset) {
      return assetFav['backgroundIDasString'];
    } else if (isAudioAsset) {
      return assetFav['audioIDasString'];
    }
    else {
      return null;
    }

  }

  getAssetFavIndex = () => {
    const assetFavIndex: string[] = [];

    (this.props.data.assetFavs as Array<AssetFav | BackgroundFav | AudioFav>).map((assetFav: (AssetFav | BackgroundFav | AudioFav)) => {
      assetFavIndex.push(this.getAssetKeyId(assetFav))
    })

    return assetFavIndex
  }

  renderAudioElement = (asset: Asset, isDeletableAsset: boolean, isFavAsset: boolean, isSharedAsset: boolean) => {
    const { t } = this.props;
    return (
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <div style={styles.imageSound}>
            <img style={styles.imgSound} alt="sound" src={asset.preview} />
          </div>
        </Grid>
        <Grid item xs={9}>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              {!asset.duration && <Box height='17px' />}
              <Tooltip title={asset.name}>
                <Typography
                  variant="subtitle2"
                  color='inherit'
                  noWrap={true}
                  style={styles.textAudio}
                  gutterBottom
                >
                  {asset.name}
                </Typography>                  
              </Tooltip>  
              {asset.duration && <Typography
                variant="caption"
                color='inherit'
                noWrap={true}
                style={styles.textAudio}
                gutterBottom
              >
                {t("leftbar.commons.length") + formatMsToMMSS(asset.duration)}
              </Typography>
              }
              <IconButton
                aria-label={t("leftbar.commons.play-pause")}
                color='inherit'
                style={{ ...styles.iconPlay }}
              >
                {this.renderToggleIconPlayPause(asset)}
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <CardActions disableSpacing>
                {this.renderUploadAssetDialogActions(asset, isDeletableAsset, isFavAsset, isSharedAsset)}
              </CardActions>
            </Grid>
          </Grid>
        </Grid>
      </Grid>);
  }

  renderSharedAssets = (asset: Asset, isDeletableAsset: boolean) => {
    

    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isBackAsset: boolean = this.props.accept === backMimeTypes.concat(backFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();
    return (
      <ImageListItem
        cols={colsGridListTile} key={`shared-asset-${asset.id}`} sx={{ cursor: 'pointer', overflow: 'hidden' }}>
        <Card cyclass={"assetDialogSharedAssetItem"} className="Card"
            style={
              this.props.handlePlayAsset && !isVideoAsset
                ? { ...styles.card, ...styles.cardSound }
                : styles.card
            }
        >
          {(isImageAsset || isBackAsset) &&
            <CardMedia
              onClick={() => { this.props.handleSelectAsset(asset) }}
              style={styles.mediaImg}
              image={asset.preview}
            />
          }
          {isAudioAsset && this.renderAudioElement(asset, isDeletableAsset, false, true)}
          {isVideoAsset && this.renderVideoAssetsDialog(asset, false, true)}
        </Card>
      </ImageListItem>
    );
  }

  renderSharedAssetEmpty = () => {
    const { t } = this.props

    const  brandConfig  = this.context;
    
    return (
      <Box p={4}>
        <Typography variant="body1">
          {t("leftbar.commons.messages.shared-empty")}
          <Link
            href={brandConfig ? brandConfig.helpUrl : 'https://help.wideo.co/hc'}
            target="_blank"
            rel="noopener" // https://material-ui.com/components/links/#security
          >
            {t("leftbar.commons.messages.shared-empty-link")}
          </Link>
        </Typography>
      </Box>
    );
  }

  renderSharedUserAssets = () => {
    const { t } = this.props;

    if (!this.props.data.assetShared.length) {
      return (<Placeholder
        icon={<PeopleAltOutlinedIcon htmlColor="#bbbbbb" fontSize="inherit" />}
        text={t('leftbar.commons.messages.any-shared')}
      />);
    }
    else {
      return this.props.data.assetShared.map((asset: Asset) => {
        const assetSharedIndex: number = this.getAssetSharedIndex().indexOf(asset.id, 0)
        return assetSharedIndex !== -1 ? (
          this.renderSharedAssets(asset, true)
        ) : null;
      });
    }
  }

  renderSharedAssetsTabContent = () => {
    
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    //shitty code. This is because videos show 1 less tab
    if (isVideoAsset && this.state.value === 3 || this.state.value === 4) {
      return (
        <DialogContent
          style={{ ...styles.dialogContent }}
        >
          <ImageList
            cols={(this.props.handlePlayAsset && this.props.data.assetShared.length) ? colsGridListMedia : !this.props.data.assetShared.length ? 1 : colsGridList}
            rowHeight={isVideoAsset ? cellHeightVideo : cellHeight}
            gap={3}
            style={{ ...styles.gridList }}
          >
            {this.renderSharedUserAssets()}
          </ImageList>
        </DialogContent>)
    } else { return <></> }
  }

  getSharedAssetKeyId = (assetShared: (Asset)): string => {
    return assetShared.id;
  }

  getAssetSharedIndex = () => {
    const assetSharedIndex: string[] = [];

    (this.props.data.assetShared as Array<Asset>).map((assetShared: (Asset)) => {
      assetSharedIndex.push(this.getSharedAssetKeyId(assetShared))
    })

    return assetSharedIndex
  }

  isColorTabSelected() {
    return this.props.customTab && this.state.value === 2;
  }

  triggerInputFile = () => { this.fileInput.click(); }

  renderDialogActions = (): JSX.Element => {
    const { t } = this.props; 

    const isBackAsset: boolean = this.props.accept === backMimeTypes.concat(backFileTypes).join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();

    if (!((isBackAsset || isAudioAsset) && this.state.value === 2)) {
      return (
        <DialogActions
          style={{ ...styles.dialogActions }}
        >
            <Button 
                cyid="assetDialogUploadButton" 
                onClick={this.triggerInputFile}
                color='primary'
                variant="contained"
                size="large"
                fullWidth       
              >
              <CloudUpload style={styles.buttonUploadIcon} />
              <Typography variant="subtitle1" color="inherit" noWrap>{t("leftbar.commons.upload")}</Typography>
            </Button>
        </DialogActions>);
    }
    else {
      return (<span key={5} />)
    }
  }

  renderAssetRestrictions = (): JSX.Element => {
    const { t } = this.props;

    const isImageAsset: boolean = this.props.accept === imageMimeTypes.concat(imageFileTypes).join();
    const isBackAsset: boolean = this.props.accept === backMimeTypes.concat(backFileTypes).join();
    const isAudioAsset: boolean = this.props.accept === audioMimeTypes.concat(audioFileTypes).join();
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    return (
      <Box mx={isAudioAsset && this.state.value !== 2 ? 1 : 0} mb={isAudioAsset && this.state.value !== 2 ? 1 : 0}>
        <Typography
          variant="caption"
          display="block"
          align="center"
          color="textSecondary"
          gutterBottom
        >
          {isImageAsset &&
            <Box cyid="imageAssetRestrictions" mx={0.5} fontSize={11}>
              {t("leftbar.commons.disclaimer1-1")}
              <Box
                mx={0.5}
                component="span"
                style={styles.fileTypes}
              >
                {imageFileTypes.join(', ')}
              </Box>
              {t("leftbar.commons.disclaimer1-2", { upToSize: ConversionUtils.bytesToMegabytes(imageMaxFileSize) })}
              <Link
                href={"https://help.wideo.co/hc/articles/4404000182925"}
                target="_blank"
                rel="noopener" // https://material-ui.com/components/links/#security
                variant="caption"
                align="center"
                underline="hover"
              >
                {t("leftbar.commons.disclaimer1-3") + " "}
                <InfoOutlinedIcon
                  fontSize="inherit"
                />
              </Link>
            </Box>
          }
          {isBackAsset && this.state.value !== 2 &&
            <Box cyid="backAssetRestrictions" mx={0.5} fontSize={11}>
              {t("leftbar.commons.disclaimer1-1")}
              <Box
                mx={0.5}
                component="span"
                style={styles.fileTypes}
              >
                {backFileTypes.join(', ')}
              </Box>
              {t("leftbar.commons.disclaimer1-2", { upToSize: ConversionUtils.bytesToMegabytes(backMaxFileSize) })}
            </Box>
          }
          {isAudioAsset && this.state.value !== 2 &&
            <Box cyid="audioAssetRestrictions" mx={0.5} fontSize={11}>
              {t("leftbar.commons.disclaimer1-1")}
              <Box
                mx={0.5}
                component="span"
                style={styles.fileTypes}
              >
                {audioFileTypes.join(', ')}
              </Box>
              {t("leftbar.commons.disclaimer1-2", { upToSize: ConversionUtils.bytesToMegabytes(audioMaxFileSize) })}
              {t("leftbar.audios.dialog.disclaimer2", { maxAudioPerWideo: audioMaxFilesWideo })}
            </Box>
          }
          {isVideoAsset &&
            <Box cyid="videoAssetRestrictions" mx={0.5} fontSize={11}>
              {t("leftbar.commons.disclaimer1-1")}
              <Box
                mx={0.5}
                component="span"
                style={styles.fileTypes}
              >
                {videoFileTypes.join(', ')}
              </Box>
              {t("leftbar.commons.disclaimer1-2", { upToSize: ConversionUtils.bytesToMegabytes(videoMaxFileSize) })}
              {t("leftbar.videos.dialog.disclaimer2", { maxDuration: videoMaxDuration })}
              {t("leftbar.videos.dialog.disclaimer3", { maxResolution: '4K' })}
              {t("leftbar.videos.dialog.disclaimer4", { maxClipsPerScene: videoMaxNoOfObjectsPerScene })}
              {t("leftbar.videos.dialog.disclaimer5", { maxClipsPerWideo: videoMaxNoOfObjectsPerWideo })}
            </Box>
          }
        </Typography>
      </Box>
    );
  }

  //handles tab click, value change
  handleChange = (event, value) => {
    this.setState({ value });
  }

  //Handle when user clicks on style
  handleOnClickStyle = (style: IWideoAssetCategory) => {
    this.setState(() => { return { styleSelected: style } });
  }

  //Handle when user clicks on stock style
  handleOnClickStockStyle = (style: IStockAssetCategory) => {
    const { t } = this.props

    this.setState({
      defaultSearch: t(`leftbar.commons.search.queries.${style.name}`),
      isSearchDialogOpen: true
    });
  }

  //Handle when user clicks back to list of styles
  handleOnClickCloseStyle = () => {
    this.setState(() => { return { styleSelected: null } });
  }

  handleOpenSearchDialog = () => {
    this.setState({ isSearchDialogOpen: true })
  }

  handleCloseSearchDialog = () => {
    this.setState({ isSearchDialogOpen: false })
  }

  resetState = (tabValue: number) => {
    const { t } = this.props;
    this.setState({
      fileSelectorOpen: false,
      styleSelected: null,
      expansionPanelDataForWideo: [],
      isToggleIconOn: false,
      defaultSearch: t("leftbar.commons.search.queries.business"),
      value: tabValue,
      isSearchDialogOpen: false
    });
    if (this.state.isDraggable) {
      this.resetDialogPosition();
    }
  }

  resetDialogPosition = () => {
    // reset position of DialogAssets 
    this.props.editor.setAssetDialogPosition(0, 0)
  }

  resetSearch = () => {
    //reset default search query of SearchDialog
    const { t } = this.props;
    this.setState({ defaultSearch: t("leftbar.commons.search.queries.business") });
  }

  handleClose = () => {
    this.props.handleCloseDialog();
  }

  handleFileSelection = (e: React.SyntheticEvent<HTMLElement>) => {
    this.props.handleFileSelection(e);
    this.fileInput.value = "";
    this.handleClose();
  }

  
  filterAudios = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Clear previous debounce timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    // Set new debounce timeout
    this.debounceTimeout = setTimeout(() => {
      this.setState({ filter: value.trim().toLowerCase() });
    }, 300);
  };


  toggleIconPlayPause = (id: string, toggleOn: boolean) => {
    this.setState({ isToggleIconOn: { [id]: toggleOn } });
  }

  handleIconPlay = (id: string, url: string) => {
    this.toggleIconPlayPause(id, true);
    this.props.handlePlayAsset(null, url, false);
  }

  handleIconPause = (id: string, url: string) => {
    this.toggleIconPlayPause(id, false);
    this.props.handlePlayAsset(null, url, true);
  }

  handleLockUnlockOptions = () => {
    this.setState(() => { return { isDraggable: !this.state.isDraggable } });
    if (!this.state.isDraggable) {
      this.resetDialogPosition();
      this.setState({ cursorName: 'grab' });
    } else {
      this.setState({ cursorName: 'default' });
    }
  };

  handleDragStart = (e: MouseEvent, data: DraggableData) => {
    this.setState({ cursorName: 'grabbing' });
  };

  handleDragStop = (e: MouseEvent, data: DraggableData) => {
    this.props.editor.setAssetDialogPosition(data.x, data.y)
    this.setState({ cursorName: 'grab' });
  };

  paperComponent = (props: PaperProps) => {
    const { isDraggable } = this.state
    return (
      <Draggable
        position={this.props.editor.getAssetDialogPosition()}
        onStart={this.handleDragStart}
        onStop={this.handleDragStop}
        bounds={'body'}
        cancel={isDraggable ?
          '[class*="MuiDialogContent-root"], [class*="MuiDialogTitle-root"], [class*="MuiPopover-root"], [class*="MuiTabs-root"], [class*="MuiButtonBase-root"]'
          : '[class*="MuiPaper-root"]'
        }
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  render() {
    
    const isVideoAsset: boolean = this.props.accept === videoFileTypes.join();

    return (
      <>
        {/*
        * this input file should be visible always.
        * because we need a reference to call "fileInput.click" when replace panel
        * need to replace with upload.
        */}
        <input
          disabled={!this.props.isDialogOpen}
          style={{...styles.inputFile, position: 'absolute', top: '-9999px', left: '-9999px' }}
          ref={fileInput => this.fileInput = fileInput}
          type="file"
          onChange={this.handleFileSelection}
          multiple={this.props.multiple || false}
          accept={this.props.accept}
          cyid="assetDialogUploadFileInput"
        />

        <CustomDialog
          maxWidth={'xs'}
          fullWidth={true}
          open={this.props.isDialogOpen}
          onClose={this.handleClose}
          hideBackdrop={this.isColorTabSelected()}
          BackdropProps={{
            invisible: true
          }}
          PaperComponent={this.paperComponent}
        >
          <Box
            color="grey.500"
            position="fixed"
            right={5}
            top={35}
            zIndex="drawer"
          >
            {this.props.handleSearchSelection &&
              <SearchButton
                editor={this.props.editor}
                handleSearchSelection={this.props.handleSearchSelection}
                assetSearchSources={this.props.assetSearchSources}
                defaultSearch={this.state.defaultSearch}
                isSearchDialogOpen={this.state.isSearchDialogOpen}
                handleOpenSearchDialog={this.handleOpenSearchDialog}
                handleCloseSearchDialog={this.handleCloseSearchDialog}
                resetSearch={this.resetSearch} />
            }
            <IconButton
              cyid="closeAssetDialog"
              onClick={this.handleClose}
              color="inherit"
              size="small"
            >
              <Close fontSize="small" color="inherit" />
            </IconButton>
          </Box>
          <AppBar position="static" style={styles.dialogAppBar}>
            <this.renderTabs />
            <this.renderBackToStylesButton />
          </AppBar>
          {!isVideoAsset && this.renderWideoObjectsTab()} {/** tab containing wideo styles from library */}
          {this.renderWideoObjectsTabStyleSelected()} {/** tab containing wideo objects when a style is selected*/}
          {this.renderStockTabContent()} {/** The dialog can load a stock tab as component */}
          {this.renderUserObjectsTab()} {/**tab containing for user objects */}
          {this.renderCustomTabContent()} {/** The dialog can load a custom tab as component */}
          {this.renderFavAssetsTabContent()} {/** The dialog can load a fav assets tab as component */}
          {this.renderSharedAssetsTabContent()} {/** The dialog can load a shared assets tab as component */}
          <this.renderDialogActions />
          <this.renderAssetRestrictions />
        </CustomDialog>
      </>
    )
  }
}

export default withTranslation("leftbar")(UploadAssetDialog);

